type SwapErrorType = "InvalidAssetIDs" | "AssetCannotBeUsedInSwap";

class SwapError extends Error {
  type: SwapErrorType;

  constructor(type: SwapErrorType, ...args: any) {
    super(...args);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, SwapError);
    }

    this.type = type;
  }
}

export default SwapError;
